import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";

export function renderTextWidget(context, widget, parent) {

    const textWidget = widget;
    const breakpoint = context.currentBreakpoint;

    // convert rgba → rgb inside content
    let content = cssUtil.convertRgbaToRgb(textWidget.content || "");
    const props = widget?.properties?.[breakpoint];
    const fontSize = cssUtil.parseInt(props.fontSize);
    content = cssUtil.updateFontSize(content, fontSize, breakpoint);
    const element = context.document.createElement("div");
    element.classList.add("widget", "text_widget");
    element.innerHTML = content;

    // auto_width logic
    const width = props?.layout?.width;
    const autoWidth = !width || width === "auto";

    if (autoWidth) {
        element.classList.add("auto_width");
    }

     const styles = {
            ...getBaseStyles(widget, breakpoint),
            ...getTextStyles(widget, breakpoint)
        };

    element.setAttribute("style", cssUtil.toStyleString(styles));
    element.setAttribute("data-widgetId", widget.uid);
    element.setAttribute("data-widgetType", widget.type);
    element.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(element);
    return element;
}

function getTextStyles(widget, breakpoint) {
    const styles = {};
    const props = widget?.properties?.[breakpoint];
    if (!props) return styles;

    const fontSize = cssUtil.parseInt(props.fontSize);
    const letterSpacingValue = cssUtil.parseDouble(props.letterSpacing);
    const lineHeight = props.lineSpacing;
    const alignment = props.alignment;
    const height = getTextHeightFromDOM(widget.uid, breakpoint);

    styles["overflow-wrap"] = "break-word";

    if (height) {
        styles["height"] = `${height}px`;
    }

    if (lineHeight) {
        styles["line-height"] = lineHeight;
    }

    if (alignment) {
        styles["text-align"] = alignment.toLowerCase();
    }

    if (!isNaN(fontSize) && !isNaN(letterSpacingValue)) {
        styles["letter-spacing"] = `${fontSize * letterSpacingValue}px`;
    }

    return styles;
}

function getTextHeightFromDOM(id, breakpoint) {
    if (breakpoint === "desktop") {
        const element = document.querySelector(`.editor_device_preview #${id}`);
        if (element) {
            return element.offsetHeight;
        }
    }
    else {
        const element = document.getElementById(id);
        if (element) {
            return element.offsetHeight;
        }
    }
}